export { default } from './P11TextIntroductionTwoColumn';
